export default __webpack_public_path__ + "static/media/safari.fcf1498c.png";